module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_8011.bc8c7a3f.png";